/**
 * @module hooks/useMounted
 * @category Hooks
 * @description Um hook que verifica se o componente está montado.
 * @returns {Object} Um objeto que indica se o componente está montado.
 */
import { useEffect, useRef } from 'react';

const useMounted = () => {
  const isMounted = useRef(true);

  useEffect(() => () => {
    isMounted.current = false;
  }, []);

  return isMounted;
};

export default useMounted;
